const API = 'https://bank.gov.ua/NBUStatService/v1/statdirectory/exchange?json'

export default API
